module.exports = __webpack_public_path__ + "static/img/20001 (5).b8a5526.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20001 (5).webp
// module id = iiUY
// module chunks = 14